import React from 'react';
import { Link } from 'react-router-dom';

function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-foreground mb-2">Terms and Conditions of Service</h1>
          <p className="text-muted-foreground mb-10">Last updated: April 30, 2026</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By creating an account or using Laftel Lingo, you agree to these Terms and Conditions.
              If you do not agree, do not use the service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">2. Use of the Service</h2>
            <p className="text-muted-foreground leading-relaxed">
              Laftel Lingo is a language learning platform for personal, non-commercial use. You must
              be at least 13 years of age to create an account. You agree not to misuse the service,
              attempt to access it through unauthorized means, or use it in any way that violates
              applicable laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">3. Accounts</h2>
            <p className="text-muted-foreground leading-relaxed">
              You are responsible for maintaining the confidentiality of your account credentials and
              for all activity that occurs under your account. Notify us immediately of any unauthorized
              use of your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">4. Subscriptions and Payments</h2>
            <p className="text-muted-foreground leading-relaxed">
              Laftel Lingo offers a free tier and a paid premium subscription. Subscription fees are
              billed in advance and are non-refundable except as required by law. You may cancel your
              subscription at any time through your account settings; access to premium features
              continues until the end of the current billing period.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">5. User Content</h2>
            <p className="text-muted-foreground leading-relaxed">
              You retain ownership of flashcard content you create. By using the service, you grant us
              a limited license to store and process that content solely to operate and deliver the
              service to you.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">6. Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All software, design, and content comprising the Laftel Lingo platform is owned by or
              licensed to us. You may not copy, modify, distribute, or create derivative works from
              any part of the service without our written permission.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">7. Disclaimer of Warranties</h2>
            <p className="text-muted-foreground leading-relaxed">
              The service is provided "as is" without warranties of any kind, express or implied. We do
              not guarantee that the service will be uninterrupted, error-free, or that AI-generated
              content will always be accurate.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">8. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              To the maximum extent permitted by law, Laftel Lingo is not liable for any indirect,
              incidental, special, or consequential damages arising from your use of the service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">9. Termination</h2>
            <p className="text-muted-foreground leading-relaxed">
              We reserve the right to suspend or terminate your account if you violate these Terms.
              You may also terminate your account at any time by contacting us.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">10. Changes to These Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update these Terms from time to time. Continued use of the service after changes
              are posted constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">11. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:support@laftel.io" className="text-primary hover:underline">
                support@laftel.io
              </a>.
            </p>
          </section>

          <div className="mt-10 pt-6 border-t border-border">
            <Link to="/" className="text-primary hover:underline">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
